import Vue from "vue";
import { $http } from "@/utils/http";

import {
    ADD_ITEM_TO_BASKET,
    ADD_PRODUCT_TO_BASKET_LOADING,
    CHANGE_SHOW_BASKET,
    CHANGE_SHOW_ORDER,
    CREATE_ORDER_LOADING,
    DECREMENT_AVAILABILITY_PROPS,
    DECREMENT_BASKET_ITEM,
    DECREMENT_BASKET_LIST_COUNT,
    ENTERED_CODE,
    INCREMENT_AVAILABILITY_PROPS,
    INCREMENT_BASKET_ITEM,
    INCREMENT_BASKET_LIST_COUNT,
    REMOVE_ITEM_FROM_BASKET,
    REMOVE_PRODUCT_FROM_BASKET_LOADING,
    RESET_AVAILABILITY_PROPS,
    RESET_BASKET,
    SEND_BASKET_LOADING,
    SEND_BASKET_RESPONSE,
    SENDING_PROMOCODE_LOADING,
    SET_AVAILABILITY_PROPS,
    SET_BASKET_EDIT_COUNT,
    SET_BASKET_LENGTH,
    SET_BASKET_LIST,
    SET_BASKET_LIST_COUNT,
    SET_BASKET_LIST_LOADING,
    SET_FAST_BUY_LOADING,
    SET_ORDER,
    SET_PROMOCODE,
} from "../mutation-types";

import { CREATE_ORDER, FAST_BUY, SEND_BASKET, SEND_PROMOCODE } from "../action-types";

function save() {
    let obj = {};
    let branchId = (JSON.parse(localStorage.getItem("branchId"))?.id || 1);

    obj.branchId = branchId;
    obj.products = state.basket;
    const parsed = JSON.stringify(obj);
    localStorage.setItem("products", parsed);
}

function calculateAmountItem(item) {
    item.totalAmount = item.select_count * (item.discount_price ? item.discount_price : item.price);
    return item;
}

const state = {
    enteredCode: "",
    promocodeLoading: false,
    promocodeStatus: "",
    showBasket: false,
    showOrder: false,
    fastBuyLoading: false,
    addBasketLoading: false,
    basketListLength: 0,
    removeBasketLoading: false,
    setBasketLoading: false,
    orderLoading: false,
    countBasketItems: 0,
    count: 1,
    basket: localStorage.getItem("products") ? JSON.parse(localStorage.getItem("products")).products : [],
    basketLoading: false,
    orderResult: null,
    orderResponse: "",
};

const getters = {
    countBasketItems: state => {
        let count = 0;
        state.basket.forEach(e => {
            count += +e.select_count;
        });
        return count;
    },
    enteredCode: state => state.enteredCode,
    promocodeLoading: state => state.promocodeLoading,
    promocodeStatus: state => state.promocodeStatus,
    showBasket: state => state.showBasket,
    addBasketLoading: state => state.addBasketLoading,
    removeBasketLoading: state => state.removeBasketLoading,
    showOrder: state => state.showOrder,
    fastBuyLoading: state => state.fastBuyLoading,
    setBasketLoading: state => state.setBasketLoading,
    basketLoading: state => state.basketLoading,
    orderLoading: state => state.orderLoading,
    basket: state => state.basket || [],
    count: state => state.count,
    basketListLength: state => state.basketListLength,
    orderResult: state => state.orderResult,
    orderResponse: state => state.orderResponse,
};

const actions = {
    [SEND_PROMOCODE]: async ({ commit }, code) => {
        commit(SENDING_PROMOCODE_LOADING, true);
        try {
            const response = await $http.get(`v1/promo_codes/${code}`);
            commit(ENTERED_CODE, code);
            commit(SET_PROMOCODE, response);
        } catch (e) {
            commit(SET_PROMOCODE, e);
            throw e;
        } finally {
            commit(SENDING_PROMOCODE_LOADING, false);
        }
    },
    [FAST_BUY]: async ({ commit }, payload) => {
        commit(SET_FAST_BUY_LOADING, true);
        try {
            return await $http.post("v1/buy-one-click", payload);
        } catch (e) {
            throw e;
        } finally {
            commit(SET_FAST_BUY_LOADING, false);
        }
    },
    [CREATE_ORDER]: async ({ commit }, payload) => {
        commit(CREATE_ORDER_LOADING, true);
        try {
            const response = await $http.post(`v1/cart/submit`, payload);
            commit(SET_ORDER, response);
        } catch (e) {
            throw e;
        } finally {
            commit(CREATE_ORDER_LOADING, false);
        }
    },
    [SEND_BASKET]: async ({ commit }, payload) => {
        commit(SEND_BASKET_LOADING, true);
        try {
            return await $http.post(`v1/cart/set`, payload);
        } catch (e) {
            throw e;
        } finally {
            commit(SEND_BASKET_LOADING, false);
        }
    },
};
const resolveProductCount = (basketProduct, quantity) => {
    basketProduct.select_count = 0;

    const setQuantity = Math.min(Math.max(Number.parseFloat(quantity || "1"), 1), basketProduct.count);

    basketProduct.select_count = Math.ceil(setQuantity);

    return basketProduct;
};

const mutations = {
    [ENTERED_CODE](state, code) {
        state.enteredCode = code;
    },
    [SENDING_PROMOCODE_LOADING](state, status) {
        state.promocodeLoading = status;
    },
    [SET_PROMOCODE](state, data) {
        state.promocodeStatus = data;
    },
    [SET_BASKET_LIST](state, list) {
        state.basket = list;

        state.basket.forEach(e => {
            calculateAmountItem(e);
        });
    },
    [SET_BASKET_LIST_LOADING](state, status) {
        state.basketLoading = status;
    },
    [SEND_BASKET_LOADING](state, status) {
        state.setBasketLoading = status;
    },
    [ADD_PRODUCT_TO_BASKET_LOADING](state, status) {
        state.addBasketLoading = status;
    },
    [REMOVE_PRODUCT_FROM_BASKET_LOADING](state, status) {
        state.removeBasketLoading = status;
    },
    [SET_BASKET_LENGTH](state, data) {
        state.basketListLength = data;
    },

    // add item to basket
    [ADD_ITEM_TO_BASKET](state, product) {
        state.basket.map((basketProduct, index) => {
            if (basketProduct.id === product.id) {
                if (basketProduct.to === product.to && basketProduct.from === product.from) {
                    product.branchId = parseInt;
                    product = resolveProductCount(
                        product,
                        parseFloat(product.select_count) + parseFloat(basketProduct.select_count)
                    );
                    Vue.delete(state.basket, index);
                }
            }
        });

        state.basket.push(calculateAmountItem(product));
        save();
    },

    //remove item
    [REMOVE_ITEM_FROM_BASKET](state, obj) {
        const index = state.basket.findIndex(e => e.id === obj.id);

        state.basket.splice(index, 1);
        save();
    },

    [RESET_BASKET](state) {
        localStorage.removeItem("products");
        state.basket = [];
    },

    // increment decrement count in basket
    [INCREMENT_BASKET_LIST_COUNT](state, basketProduct) {
        basketProduct = resolveProductCount(basketProduct, basketProduct.select_count + 1);
        // console.log(basketProduct);
        Vue.set(state.basket, basketProduct.index, calculateAmountItem(basketProduct));
        save();
    },
    [SET_BASKET_LIST_COUNT](state, obj) {
        // const index = state.basket.findIndex(e=> e.id === obj.id)
        Vue.set(state.basket, obj.index, calculateAmountItem(obj));
        save();
    },
    [DECREMENT_BASKET_LIST_COUNT](state, basketProduct) {
        const index = state.basket.findIndex(e => e.id === basketProduct.id);
        basketProduct = resolveProductCount(basketProduct, basketProduct.select_count - 1);
        Vue.set(state.basket, index, calculateAmountItem(basketProduct));
        save();
    },
    [SET_AVAILABILITY_PROPS](state, basketProduct) {
        // console.log(basketProduct)orderResponse;
        const index = state.basket.findIndex(e => e.id === basketProduct.id);
        basketProduct = resolveProductCount(basketProduct, basketProduct.newCount);
        Vue.set(state.basket, index, calculateAmountItem(basketProduct));
        save();
    },

    [SET_BASKET_EDIT_COUNT](state, val) {
        state.editCount = val;
    },
    [CHANGE_SHOW_BASKET](state, status) {
        state.showBasket = status;
    },
    [CHANGE_SHOW_ORDER](state, status) {
        state.showOrder = status;
    },
    [DECREMENT_AVAILABILITY_PROPS](state) {
        if (state.count > 1) {
            state.count--;
        }
    },
    [INCREMENT_AVAILABILITY_PROPS](state) {
        state.count++;
    },

    [RESET_AVAILABILITY_PROPS](state) {
        state.count = 1;
    },
    [DECREMENT_BASKET_ITEM](state) {
        state.count++;
    },
    [INCREMENT_BASKET_ITEM](state) {
        if (state.count > 1) {
            state.count--;
        }
    },
    [SET_FAST_BUY_LOADING](state, status) {
        state.fastBuyLoading = status;
    },
    [CREATE_ORDER_LOADING](state, status) {
        state.orderLoading = status;
    },
    [SET_ORDER](state, data) {
        state.orderResult = data;
    },
    [SEND_BASKET_RESPONSE](state, data) {
        state.orderResponse = data;
    },
};
export default {
    state,
    getters,
    actions,
    mutations,
};
